const en = {
    title: 'The DApps and DeFis you love',
    subtitle: 'The way you connect to blockchain',
    download: 'Download Wallet',
    thanks: 'Special Thanks To Community Support',
    add: 'Add To TokenPocket',
    scanSave: 'Collect after scanning with TokenPocket',
    submitDApps: 'submit DApps'
};

export default en;
